module.exports = __webpack_public_path__ + "static/media/copy-link.64402e77.svg";